import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BrandContextService {
  readonly brandId = signal<string | null>(null);
}
